import Modal from "../components/Modal";
import React, { useContext, useState } from "react";

export interface ModalImage {
  src?: string;
  title?: string;
}

interface ImageContextValue {
  image: ModalImage;
  setImage: (image: ModalImage) => void;
}

const ImageContext = React.createContext<ImageContextValue | null>(null);

function ImageModalProvider({ children }: { children: React.ReactNode }) {
  const [image, setImage] = useState<ModalImage>({});

  return (
    <ImageContext.Provider value={{ image, setImage }}>
      {children}
    </ImageContext.Provider>
  );
}

function useImageModal() {
  return useContext(ImageContext) || { image: {}, setImage: () => 0 };
}

function ImageModal() {
  const {
    image: { src, title },
    setImage,
  } = useImageModal();

  if (!src) {
    return null;
  }

  return (
    <Modal open={!!src} onClose={() => setImage({})}>
      <header>
        <h2>{title}</h2>
      </header>
      <section className="flex flex-row items-center max-h-full">
        <div
          className="h-96 w-full max-h-full bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${src})` }}
        />
      </section>
    </Modal>
  );
}

export default ImageModal;
export { ImageModalProvider, useImageModal };
